import { Badge, Icon, WithTooltip } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { CatalogItemIndicatorStyled } from './styles/CatalogItemIndicatorStyled'

export const CatalogItemIndicator = () => {
  const intl = useProcurifyIntl()

  return (
    <WithTooltip
      title={intl.formatMessage(messages.tooltipText)}
      placement='top'
    >
      <CatalogItemIndicatorStyled
        role='img'
        aria-label={intl.formatMessage(messages.imageDescription)}
      >
        <Badge color='primary'>
          <Icon icon='catalog' />
        </Badge>
      </CatalogItemIndicatorStyled>
    </WithTooltip>
  )
}

CatalogItemIndicator.displayName = 'CatalogItemIndicator'
